import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Grid, IconButton } from "@mui/material";
import { postsStore } from "../../../../stores/posts/postsStore";
import { ImagePreview } from "../Photos/PhotoUploader";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import { alertService, setBackdrop, useAsyncDeleteAction, BtnLoad } from "common-frontend-components";
import { callDeletePostAsync } from "../../../../apis/posts";
import { callDeletePostCategoryAssociationAsync } from "../../../../apis/postCategoryAssociations";
import { postCategoryAssociationsStore } from "../../../../stores/posts/usePostCategoryAssociationsStore";
import { photosStore } from "../../../../stores/posts/usePhotosStore";
import { onDeletePhoto } from "../Photos/PhotoCard";
import { timeSince } from 'common-frontend-components';
import { postCardStyle } from "../../../../assets/styles/styles";
import { textColor } from "../../../../assets/styles/colors";
import EditIcon from '@mui/icons-material/Edit';
import { EditPost } from "./EditPost";
import { CategoryChip } from "../../categories/CategoryChip";
import { PostLinks } from "./PostLinks";
import { productPostAssociationsStore } from "../../../../stores/products/productPostAssociationsStore";
// import {WwwProductCard} from "../Products/WwwProductCard";
import { PostProductsCarousel } from "../../products/product/PostProductsCarousel";
import { callDeleteProductPostAssociationAsync } from "../../../../apis/productPostAssociations";
export const createOnDeletePost = (post) => async () => {
    const response = {
        error: undefined,
    };
    setBackdrop(true);
    try {
        const associations = postCategoryAssociationsStore.getAssociationsByPostId(post.id);
        const productAssociations = productPostAssociationsStore.getAssociationsByPostId(post.id);
        const photos = photosStore.getPhotosById(post.id);
        if (photos) {
            await Promise.all(photos.map(photo => onDeletePhoto(photo)));
        }
        for (const i of associations) {
            await callDeletePostCategoryAssociationAsync(i.id);
            postCategoryAssociationsStore.setPostCategoryAssociations(postCategoryAssociationsStore.getPostCategoryAssociations().filter(ii => i.id !== ii.id));
        }
        for (const i of productAssociations) {
            await callDeleteProductPostAssociationAsync(i.id);
            productPostAssociationsStore.setProductPostAssociations(productPostAssociationsStore.getProductPostAssociations().filter(ii => i.id !== ii.id));
        }
        callDeletePostAsync(post.id);
        postsStore.setPosts(postsStore.getPosts().filter(i => post.id !== i.id));
    }
    catch (e) {
        response.error = e;
        alertService.error(e);
    }
    finally {
        setBackdrop(false);
    }
    return response;
};
const DeletePost = ({ post }) => {
    const { handleClick, isSubmitting } = useAsyncDeleteAction({
        name: 'post',
        value: post.title,
        onClick: createOnDeletePost(post),
    });
    return (_jsx(Button, { size: "small", onClick: handleClick, children: _jsx(BtnLoad, { loading: isSubmitting, text: "Delete Post", loadText: "Deleting Post" }, void 0) }, void 0));
};
export const AdminPostCard = ({ post }) => {
    const photos = photosStore.usePhotosByPostId(post.id);
    const postCategoryAssociations = postCategoryAssociationsStore.usePostCategoryAssociations();
    const productPostAssociations = productPostAssociationsStore.useProductPostAssociations();
    const categories = useMemo(() => postCategoryAssociationsStore.getPostCategories(post.id), [postCategoryAssociations]);
    const products = useMemo(() => productPostAssociationsStore.getPostProducts(post.id), [productPostAssociations]);
    const [isEdit, setIsEdit] = useState(false);
    if (isEdit) {
        const onClose = () => setIsEdit(false);
        const onPostChange = (p) => {
            postsStore.setPosts(postsStore.getPosts().map(i => {
                if (i.id === p.id)
                    return p;
                return i;
            }));
        };
        return (_jsx(EditPost, { post: post, onCancel: onClose, categories: categories, products: products, onSuccess: onClose, onPostUpdate: onPostChange }, void 0));
    }
    return (_jsx(Box, { sx: { minWidth: 275 }, children: _jsxs(Card, { variant: "outlined", sx: postCardStyle, children: [_jsxs(CardContent, { children: [_jsxs(Grid, { container: true, alignItems: "flex-start", children: [_jsxs(Typography, { sx: { fontSize: '1.5rem', fontWeight: 600, paddingBottom: 1, color: textColor }, color: "text.secondary", gutterBottom: true, children: [post.title, _jsx(Box, { sx: { fontSize: '.85rem', fontWeight: 300, color: textColor + '55' }, children: timeSince(new Date(post.created)) }, void 0)] }, void 0), _jsx(Box, { sx: { flexGrow: 1 } }, void 0), _jsx(IconButton, { color: 'info', onClick: () => setIsEdit(true), children: _jsx(EditIcon, {}, void 0) }, void 0)] }, void 0), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { sx: { fontSize: '1rem', color: textColor, whiteSpace: "pre-wrap" }, color: "text.secondary", gutterBottom: true, children: post.description }, void 0) }, void 0), photos &&
                                    _jsx(Grid, { item: true, children: _jsx(ImagePreview, { photos: photos, index: 0 }, void 0) }, void 0), _jsx(PostLinks, { post: post }, void 0), products.length > 0 ? _jsx(Grid, { item: true, xs: 12, children: _jsx(PostProductsCarousel, { items: products }, void 0) }, void 0) : null] }, void 0)] }, void 0), _jsx(CardActions, { children: _jsxs(Grid, { container: true, spacing: 1, children: [categories.map(i => _jsx(Grid, { item: true, children: _jsx(CategoryChip, { category: i }, void 0) }, i.id)), _jsx(Grid, { item: true, children: _jsx("div", { style: { paddingLeft: 4, paddingRight: 4 }, children: _jsx(DeletePost, { post: post }, void 0) }, void 0) }, void 0)] }, void 0) }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=AdminPostCard.js.map